// Display labels for the Hades vocabularies. The values are defined in
// cerberus/cerberus/hades/config.yaml (queues, work_categories) and stored as
// written; only the LABEL lives here.
//
// A new queue in config.yaml with no entry here still renders — it falls back to
// its raw key rather than disappearing.

export const QUEUE_LABELS = {
  unnoticed: 'Unnoticed',
  active: 'Active',
  awaiting_deploy: 'Awaiting deploy',
  recently_completed: 'Recently completed',
  shipped_record_stale: 'Shipped / record stale',
  necessary_unvoiced: 'Necessary / unvoiced',
  dormant: 'Dormant',
  irrelevant: 'Irrelevant',
  nice_to_have: 'Nice to have',
  needs_evidence: 'Unknown',
};

// Deliberately grey, not red. An Unknown verdict is an honest answer about the
// evidence, not a failure — and it carries no recommended action, so it must not
// read as something to go and fix.
export const QUEUE_CLASSES = {
  unnoticed: 'bg-yellow-light text-gray-900',
  active: 'bg-secondary-300 text-gray-900',
  awaiting_deploy: 'bg-neutral-100 text-gray-900',
  recently_completed: 'bg-secondary-200 text-gray-900',
  shipped_record_stale: 'bg-primary-100 text-gray-900',
  necessary_unvoiced: 'bg-neutral-50 text-gray-900',
  dormant: 'bg-gray-25 text-gray-700',
  irrelevant: 'bg-gray-50 text-gray-700',
  nice_to_have: 'bg-gray-25 text-gray-700',
  needs_evidence: 'bg-gray-50 text-gray-600',
};

// The queue where the evidence is strong enough to act on: delivery is a deploy
// state AND the record is still open. shipped_record_stale is the only one with
// a cited PR behind it — recently_completed often has no delivery proof, and
// irrelevant needs a human to confirm the duplicate's target.
export const CLOSEABLE_QUEUES = ['shipped_record_stale'];

export const CATEGORY_LABELS = {
  customer_feature: 'Customer feature',
  bug_fix: 'Bug fix',
  app_stability_reliability: 'Reliability',
  architecture_platform: 'Architecture',
  data_integration: 'Data integration',
  security_compliance: 'Security',
  internal_tooling: 'Internal tooling',
  documentation: 'Documentation',
  maintenance: 'Maintenance',
  unclassified: 'Unclassified',
};

export const LINKAGE_LABELS = {
  direct_customer_demand: 'Direct customer demand',
  indirect_customer_value: 'Indirect customer value',
  necessary_unvoiced: 'Necessary, unvoiced',
  no_established_link: 'No established link',
  unknown: 'Unknown',
};

export const DELIVERY_LABELS = {
  not_started: 'Not started',
  partial: 'Partial',
  implemented_unmerged: 'Implemented, unmerged',
  in_review: 'In review',
  merged_not_deployed: 'Merged, not deployed',
  deployed_unverified: 'Deployed',
  deployed_customer_confirmed: 'Deployed, confirmed',
  regressed: 'Regressed',
  closed_unmerged: 'Closed unmerged',
  unknown: 'Unknown',
};
